import { TRUE } from "constants/primitives";
import { NUMBER_1 } from "constants/numbers";

/**
 * DNT is a string API: "1" today, "yes" in Firefox before 32.
 * IE 11 and Safari 7.1.3+ expose it on window instead of navigator.
 */
const DNT_ENABLED_VALUES = [`${NUMBER_1}`, "yes"];

/**
 * True when the visitor asked not to be tracked, through GPC or legacy DNT.
 *
 * Reads only the JS property - the Sec-GPC header never reaches page scripts,
 * so browsers that send just the header stay invisible here. Strict === true
 * because an explicit false means "do not opt out".
 */
const hasPrivacyOptOutSignal = (): boolean =>
  navigator.globalPrivacyControl === TRUE ||
  DNT_ENABLED_VALUES.includes(navigator.doNotTrack || "") ||
  DNT_ENABLED_VALUES.includes(window.doNotTrack || "");

export default hasPrivacyOptOutSignal;
